import React, { useState } from "react";
import SignUpForm from "./SignUpForm";
import { loadStripe } from "@stripe/stripe-js/pure";
import { Elements } from "@stripe/react-stripe-js";
import { useParams } from "react-router-dom";

export default function Register() {
  const [errorMessage, setErrorMessage] = useState(undefined);
  const { priceId } = useParams();

  // eslint-disable-next-line no-undef
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

  function updateError(message) {
    setErrorMessage(message);
  }

  return (
    <Elements stripe={stripePromise}>
      <SignUpForm
        errorMessage={errorMessage}
        updateError={updateError}
        priceId={priceId}
      />
    </Elements>
  );
}
